import Box from '@mui/material/Box'
import MessageModal from '../../../components/MessageModal'
import useCancelRegistration from '../hooks/useCancelRegistration'
import Background from '../../../layouts/Background'

export default function Cancel() {
    const { message, setMessage } = useCancelRegistration()

    return (
        <Background>
            <Box sx={{ minHeight: '70vh' }}>
                {message && <MessageModal message={message} setMessage={setMessage} />}
            </Box>
        </Background>
    )
}
